common.View.create('galaxy::common.form.dataset.Card', {

	onDOMLoad()
	{
		this.initGui();
	},

	initGui()
	{
		this.element

			.find('.card-title')
			.click(this.onTitleClick)
			.end();
	},

	onTitleClick(event)
	{
		$(event.currentTarget)

			.parent()
			.find('.dataset-content')

			// Show and hide content
			.slideToggle(function ()
			{
				$(this).parent().find('.card-title .drop-toggle i')
					.removeClass()
					.addClass($(this).is(':hidden') ? 'fa fa-caret-right' : 'fa fa-caret-down');
			})
			.end();
	},

});